import * as React from 'react';

import SitemapListLayout from '@/components/pages/sitemap/components/sitemap-list-layout';
import { Category } from '@/utils/functions/wordpress/fetch-categories';

type SitemapTagsPageLayoutProps = {
    categories: Category[];
};

const SitemapCategoriesPageLayout = (props: SitemapTagsPageLayoutProps) => {
    const { categories } = props;
    const title = 'Categories';

    return (
        <SitemapListLayout
            title={title}
            path="/category"
            description="Index of all categories used within articles."
            items={categories.map(category => ({
                name: category.name,
                slug: category.slug,
                description: category.description || `${category.count} associated articles.`,
            }))}
            breadcrumb={{
                title,
                link: '/sitemap/categories',
            }}
        />
    );
};

export default SitemapCategoriesPageLayout;
